import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useSurgeryIndex } from '@/lib/store';
import { getProcedureDisplayName } from '@/lib/catalog';
import { routeMeta } from '@/lib/route-meta';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

/** Syncs the browser tab title from the current route (and surgery folio when known). */
export function DocumentTitle() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const surgeryIndex = useSurgeryIndex();

  const folio = (() => {
    const m = /^\/(?:surgery|edit)\/([^/]+)$/.exec(pathname);
    if (!m) return undefined;
    return surgeryIndex.find((c) => c.id === m[1])?.folio;
  })();

  const procedureName = (() => {
    const m = /^\/surgery\/([^/]+)$/.exec(pathname);
    if (!m) return undefined;
    const s = surgeryIndex.find((c) => c.id === m[1]);
    if (!s) return undefined;
    return getProcedureDisplayName(s.categoria);
  })();

  const { documentTitle } = routeMeta(t, pathname, { folio, procedureName });
  useDocumentTitle(documentTitle);
  return null;
}
